import { shopScene } from '../shopkit.js';

/** 大车店：便宜的床，贵的信息。睡一觉既补精神，也听一耳朵闲话。 */
export const innDoc = shopScene({
  id: 'inn',
  name: '大车店',
  shop: 'inn',
  owner: '店家',
  desc: '通铺、草料味，半夜有人在说城里的新鲜事。',
  w: 24, h: 18,
  counters: [{ gx: 9, gy: 3, len: 5, kind: 'inn' }],
  props: [
    { type: 'long_table', gx: 5, gy: 12 },
    { type: 'long_table', gx: 6, gy: 12 },
    { type: 'guest_futon', gx: 15, gy: 7 },
    { type: 'guest_futon', gx: 18, gy: 7 },
    { type: 'hay_pile', gx: 3, gy: 14 },
    { type: 'notice_board', gx: 20, gy: 12 },
  ],
  portals: [
    { to: 'market', gx: 12, gy: 17, spawn: [40, 9], label: '回市集' },
  ],
});

export default innDoc;
